import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SsomaService {

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private router: Router
  ) {}

  getParametersConfig(Parameters: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/getParametersConfig`, Parameters);
  }

  getFormsConfig(): Observable<any> {
    return this.http.post(`${environment.apiUrl}/indama/ssoyma/getFormsConfig`, {});
  }

}
